import requests from "./httpServices";

export const getMeetingRooms = (currentPage, rowsPerPage, ownedOnly = false) => {
  const suffix = ownedOnly ? `&ownedOnly=true` : "";
  return requests.get(`/rooms?page=${currentPage}&limit=${rowsPerPage}${suffix}`);
};

export const getScheduleMeeting = (currentPage, rowsPerPage) => {
  return requests.get(
    `/rooms/list-scheduled-meetings?page=${currentPage}&limit=${rowsPerPage}`
  );
};

export const getMeetingRoomById = (roomId) => {
  return requests.get(`/rooms/${roomId}`);
};

export const createMeetingRoom = (roomData) => {
  return requests.post("/rooms", roomData);
};

export const deleteMeetingRoom = (id) => {
  return requests.delete(`/rooms/${id}`);
};

export const updateMeetingRoom = (roomId, roomData) => {
  return requests.post(`/rooms/${roomId}`, roomData);
};

export const checkCreateRoomAailability = () => {
  return requests.get("/rooms/create-room-vailability");
};

export const createScheduledMeeting = (roomData) => {
  return requests.post("/rooms/create-schedule-meeting", roomData);
};

export const updateScheduledMeeting = (roomId, roomData) => {
  return requests.post(`/rooms/update-schedule-meeting/${roomId}`, roomData);
};

export const getScheduledMeetingById = (roomId) => {
  return requests.get(`/rooms/get-schedule-meeting/${roomId}`);
};

export const deleteScheduledMeeting = (roomId) => {
  return requests.delete(`/rooms/delete-schedule-meeting/${roomId}`);
};

export const checkRoomNameExists = (roomName) => {
  return requests.get(`/rooms/check-name/${encodeURIComponent(roomName)}`);
};

export const checkPermalinkExists = (permalink, excludeRoomId) => {
  const query = excludeRoomId ? `?excludeRoomId=${excludeRoomId}` : '';
  return requests.get(`/rooms/check-permalink/${encodeURIComponent(permalink)}${query}`);
};

export const getLastMeetingSession = (roomId) => {
  return requests.post(`/rooms/meeting-last-session`, { roomId: roomId });
};

export const submitFeedback = (feedbackData) => {
  return requests.post(`/rooms/submit-feedback`, feedbackData);
};

export const getAllFeedback = () => {
  return requests.get(`/rooms/feedback`);
};

// Webinar dashboard
export const listWebinars = () => {
  return requests.get(`/rooms/webinars`);
};

export const getWebinarRegistrants = (webinarId) => {
  return requests.get(`/rooms/webinars/${webinarId}/registrants`);
};

export const approveRegistrant = (webinarId, email) => {
  return requests.patch(`/rooms/webinars/${webinarId}/registrants/${encodeURIComponent(email)}/approve`);
};

export const rejectRegistrant = (webinarId, email) => {
  return requests.delete(`/rooms/webinars/${webinarId}/registrants/${encodeURIComponent(email)}`);
};

export const resendConfirmationEmail = (webinarId, email) => {
  return requests.post(`/rooms/webinars/${webinarId}/registrants/${encodeURIComponent(email)}/resend`);
};

export const getAllWebinarRegistrations = () => {
  return requests.get(`/rooms/webinars/all-registrations`);
};

export const sendReplayEmail = (webinarId) => {
  return requests.post(`/rooms/webinars/${webinarId}/send-replay-email`);
};

export const startWebinar = (roomId) => {
  return requests.post(`/rooms/webinars/${roomId}/start`);
};

export const endWebinar = (roomId) => {
  return requests.post(`/rooms/webinars/${roomId}/end`);
};

export const getActiveRoomStatus = () => {
  return requests.get(`/rooms/active-status`);
};